import React from "react";

const IconCart = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={22}
      height={22}
      viewBox="0 0 22 22"
      fill="none"
      {...props}
    >
      <path
        d="M17.2895 16.946C17.8422 16.946 18.3722 17.1615 18.763 17.5452C19.1538 17.9289 19.3733 18.4492 19.3733 18.9918C19.3733 19.5344 19.1538 20.0548 18.763 20.4385C18.3722 20.8222 17.8422 21.0377 17.2895 21.0377C16.7369 21.0377 16.2069 20.8222 15.8161 20.4385C15.4253 20.0548 15.2057 19.5344 15.2057 18.9918C15.2057 17.8564 16.133 16.946 17.2895 16.946ZM0.619141 0.578857H4.02615L5.00554 2.62474H20.4152C20.6916 2.62474 20.9566 2.73252 21.152 2.92436C21.3474 3.1162 21.4571 3.37639 21.4571 3.64769C21.4571 3.82159 21.405 3.99549 21.3321 4.15916L17.6021 10.7776C17.2479 11.4016 16.5602 11.8312 15.7788 11.8312H8.01663L7.07892 13.4986L7.04766 13.6214C7.04766 13.6892 7.0751 13.7543 7.12395 13.8022C7.1728 13.8502 7.23905 13.8771 7.30814 13.8771H19.3733V15.923H6.87054C6.31788 15.923 5.78786 15.7075 5.39707 15.3238C5.00628 14.9401 4.78674 14.4197 4.78674 13.8771C4.78674 13.5191 4.88051 13.1815 5.0368 12.8951L6.45378 10.3889L2.70294 2.62474H0.619141V0.578857ZM6.87054 16.946C7.4232 16.946 7.95322 17.1615 8.34401 17.5452C8.7348 17.9289 8.95434 18.4492 8.95434 18.9918C8.95434 19.5344 8.7348 20.0548 8.34401 20.4385C7.95322 20.8222 7.4232 21.0377 6.87054 21.0377C6.31788 21.0377 5.78786 20.8222 5.39707 20.4385C5.00628 20.0548 4.78674 19.5344 4.78674 18.9918C4.78674 17.8564 5.71403 16.946 6.87054 16.946ZM16.2476 9.78535L19.1441 4.67063H5.9745L8.43339 9.78535H16.2476Z"
        fill="#FDF2DE"
      />
    </svg>
  );
};

export default IconCart;
